Vue.component('theme-switch', {
  template: templates.themeSwitch,
  data() {
    return {
      model: {
        theme: utils.cookies.get('theme') && utils.cookies.get('theme') === 'false' ? false : true
      }
    }
  },
  methods: {
    save() {
      const c = this;

      utils.cookies.set('theme', c.model.theme);

      if (c.model.theme) {
        $('body').addClass('dark');
      } else {
        $('body').removeClass('dark');
      }

      userService.update();
    }
  }
});